import React from 'react';
import { SvgIcon, } from './SvgIcon';
export const MinusIcon = ({ color = '#AAA', ...rest }) => (React.createElement(SvgIcon, Object.assign({ color: color, viewBox: "0 0 24 24", titleAccess: "Minus icon" }, rest),
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
        React.createElement("path", { d: "M3 10h18v4H3z", fill: "currentColor" }))));
